import { FC, useCallback } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import * as S from './styles';

const msgs = defineMessages({
  backToTop: {
    id: 'back_to_top',
    defaultMessage: 'Back to top',
  },
});

export const BackToTopArrow: FC = () => {
  const intl = useIntl();
  const ariaText = intl.formatMessage(msgs.backToTop);

  const onClick = useCallback(() => {
    const modalContent = document.querySelector('.reactModalContent') as HTMLElement;
    (modalContent || window).scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  return (
    <S.Container aria-label={ariaText} title={ariaText} onClick={onClick} data-testid="back-to-top">
      <S.ArrowIcon name="backwards" />
    </S.Container>
  );
};
